// convex/lib/config/modules.ts
// Source of truth for module IDs - must match convex/schema.ts exactly

/**
 * IMPORTANTE: Esta lista DEBE coincidir exactamente con las tablas en convex/schema.ts
 * Los nombres aquí son los identificadores únicos de módulos/tablas del sistema
 */
export const MODULES = [
  // AI
  "ai_agent_config",
  "ai_assistant",
  "ai_insights",
  "ai_usage",

  // System
  "audit_logs",
  "branches",
  "companies",
  "company_subscriptions",
  "nomenclature",
  "notifications",
  "subscription_plans",
  "ai_settings",
  "control_panel",
  "deleted_records",
  "invoices_exempts_documents",

  "user_invitations",
  "users",
  "profiles",
  "waitlist",

  // Security
  "permissions",
  "roles",

  // Clients & Sales
  "client_credits",
  "client_exemptions",
  "clients",
  "clients_exempt_documents",
  "sales",
  "sales_items",
  "sellers",

  // Invoices
  "invoices",
  "invoices_cancelation_requests",
  "invoices_configuration_exempts",
  "invoices_configurations",
  "invoices_exemptions",
  "invoices_items",
  "invoices_payments",

  // Credit Notes
  "credit_notes",
  "credit_notes_configurations",
  "debit_notes",
  "debit_notes_configurations",

  // Purchasing
  "purchase_orders",
  "purchase_orders_items",

  // Stock transfers
  "stock_transfers",
  "stock_transfers_items",

  // Warehouses
  "warehouses",

  // Stock reservations
  "stock_reservations",

  // Inventory counts
  "inventory_counts",
  "inventory_counts_items",

  // Catalog
  "brands",
  "categories",
  "products",
  "services",
  "suppliers",

  // Quotations
  "quotations",
  "quotations_items",

  // Stock
  "stock_configurations",
  "stock_movements",
  "stock_status",
  "stock",

  // Operations
  "equipment",
  "personnel",
  "personnel_roles",
  "work_order_equipment",
  "work_order_expenses",
  "work_order_logs",
  "work_order_personnel",
  "work_orders",
  "work_order_services",
  "work_order_products",

  // Configuration
  "correlatives",
  "documents_types",
  "emission_points",

  // Reports
  "pipeline_tracking",
  "report_executions",
  "report_shares",
  "reports",

  // Documents
  "attachments",
  "document_records",
  "document_templates",
  "custom_fields",
  "native_field_settings",
  "pdf_templates",
  "pdf_template_versions",
  "pdf_template_assets",
  "email_templates",
  "email_template_versions",
  "collections",
  "collection_records",
  "collection_automations",
  "collection_action_runs",
  "collection_action_campaigns",
  "collection_action_definitions",
  "collection_action_signatures",

  // Integrations
  "integrations",
  "integration_connections",
  "integration_triggers",
  "integration_executions",
  "scripts",
  // MCP de empresa (agentes de IA): solo planes superiores.
  "mcp",
  "mcp_tokens",
  "mcp_calls",
  "mcp_confirmations",
  "entity_tags",
  "tags",

  // Auth
  "authAccounts",
  // dashboard
  // settings,
  "dashboard",
  "settings",

  // Security settings (módulo virtual, sin tabla propia; está en
  // ALWAYS_ENABLED_MODULES y lo siembra el onboarding, así que DEBE estar acá
  // o el validador de permisos rechaza el insert).
  "platformsAndSessions",

  // On-prem licensing
  "licensing",
  "licenses",
] as const;

export type ModuleId = (typeof MODULES)[number];

/**
 * Helper para verificar si un string es un modulo valido
 */
export function isValidModuleId(value: string): value is ModuleId {
  return (MODULES as readonly string[]).includes(value);
}
